/**
 * Reducer for the Second Chance Delivery tutorials.
 */

import { SET_TUTORIALS_COMPLETED, RESET_TUTORIALS } from '../actions';
import { START_SCD_NEW_FILL_TUTORIAL } from '../tutorial-actions/second-chance-delivery';
import { QUESTION_ACTIVITY_FINISHED } from 'phoenix2/state/question-activity/actions';
import { EVALUATIONS } from 'phoenix2/state/question-activity/question-activity';

export const SCD_NEW_FEATURE_TUTORIAL_KEY = 'secondChanceDeliveryNewFeature';
export const SCD_NEW_FILL_TUTORIAL_KEY = 'secondChanceDeliveryNewFill';
export const SCD_ONBOARDING_TUTORIAL_KEY = 'secondChanceDeliveryOnboarding';

export interface ISCDState {
    completed: boolean;
    active: boolean;
}

const newFeatureInit: ISCDState = {
    completed: false,
    // The SCD new feature tutorial is active by default
    active: true,
};

export function SCDNewFeatureTutorialReducer(state = newFeatureInit, action: any): ISCDState {
    switch (action.type) {
        case RESET_TUTORIALS:
            return newFeatureInit;
        case SET_TUTORIALS_COMPLETED:
            if (action.tutorialIds.indexOf(SCD_NEW_FEATURE_TUTORIAL_KEY) !== -1) {
                return {
                    completed: true,
                    active: false,
                };
            }
            break;
    }

    return state;
}

export interface ISCDNewFillState extends ISCDState {
    taskItemId?: string;
}

const newFillInit: ISCDNewFillState = {
    completed: false,
    // The SCD new fill tutorial isn't active until a new fill is given
    active: false,
    taskItemId: undefined,
};

export function SCDNewFillTutorialReducer(state = newFillInit, action: any): ISCDNewFillState {
    switch (action.type) {
        case RESET_TUTORIALS:
            return newFillInit;
        case SET_TUTORIALS_COMPLETED:
            if (action.tutorialIds.indexOf(SCD_NEW_FILL_TUTORIAL_KEY) !== -1) {
                return {
                    completed: true,
                    active: false,
                    taskItemId: undefined,
                };
            }
            break;
        case START_SCD_NEW_FILL_TUTORIAL:
            return {
                completed: false,
                active: true,
                taskItemId: action.taskItemId,
            };
        case QUESTION_ACTIVITY_FINISHED:
            if (
                action.evaluation === EVALUATIONS.correct &&
                action.questionActivity.get('taskItemId') === state.taskItemId
            ) {
                return {
                    completed: true,
                    active: false,
                    taskItemId: undefined,
                };
            }
            break;
    }

    return state;
}

const onboardingInit: ISCDState = {
    completed: false,
    // The SCD onboarding tutorial is active by default
    active: true,
};

export function SCDOnboardingTutorialReducer(state = onboardingInit, action: any): ISCDState {
    switch (action.type) {
        case RESET_TUTORIALS:
            return newFeatureInit;
        case SET_TUTORIALS_COMPLETED:
            if (action.tutorialIds.indexOf(SCD_ONBOARDING_TUTORIAL_KEY) !== -1) {
                return {
                    completed: true,
                    active: false,
                };
            }
            break;
    }

    return state;
}
